<table class="table table-striped mb-0" *ngIf="data?.length > 0">
  <thead class="thead-light">
    <tr>
      <th *ngFor="let column of columns; let i = index" [ngClass]="{ 'text-center': i > 0 ? true : false }">{{ column }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item_x of data">
      <td [ngClass]="{ 'row-active': item_x?.active ? true : false, 'sticky': item_x?.active && sticky }">
        {{ item_x.description }}
      </td>
      <td class="text-center"
          [ngClass]="{ 'row-active': item_x?.active ? true : false, 'sticky': item_x?.active && sticky }" 
          *ngFor="let item_y of item_x?.detail">
        <ng-container *ngIf="getConditionExportByType(item_x, item_y)">
          <button type="button" (click)="onClickExport(item_x, item_y)">
            {{ item_y.value }}
          </button>
        </ng-container>
        <ng-container *ngIf="!getConditionExportByType(item_x, item_y)">
          {{ item_y.value }}
        </ng-container>
      </td>
    </tr>
  </tbody>
</table>